package team.platforma.multiplatform_material_extension.calendar.core

import androidx.compose.runtime.Composable
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.mel_April
import materialextension.multiplatform_material_extension.generated.resources.mel_August
import materialextension.multiplatform_material_extension.generated.resources.mel_December
import materialextension.multiplatform_material_extension.generated.resources.mel_February
import materialextension.multiplatform_material_extension.generated.resources.mel_January
import materialextension.multiplatform_material_extension.generated.resources.mel_July
import materialextension.multiplatform_material_extension.generated.resources.mel_June
import materialextension.multiplatform_material_extension.generated.resources.mel_March
import materialextension.multiplatform_material_extension.generated.resources.mel_May
import materialextension.multiplatform_material_extension.generated.resources.mel_November
import materialextension.multiplatform_material_extension.generated.resources.mel_October
import materialextension.multiplatform_material_extension.generated.resources.mel_September
import org.jetbrains.compose.resources.stringResource

@Composable
fun CALENDAR(): Calendar {
    return CalendarImpl().newInstance()
}

interface Calendar {
    fun months(): CalendarMonths
    fun getMonthByNumber(number: Int): String
}

internal class CalendarImpl : Calendar {
    private var listMonths = listOf<String?>()
    private lateinit var calendarMonths: CalendarMonths

    @Composable
    fun newInstance(): CalendarImpl {
        calendarMonths = CalendarMonths(
            january = stringResource(Res.string.mel_January),
            february = stringResource(Res.string.mel_February),
            march = stringResource(Res.string.mel_March),
            april = stringResource(Res.string.mel_April),
            may = stringResource(Res.string.mel_May),
            june = stringResource(Res.string.mel_June),
            july = stringResource(Res.string.mel_July),
            august = stringResource(Res.string.mel_August),
            september = stringResource(Res.string.mel_September),
            october = stringResource(Res.string.mel_October),
            november = stringResource(Res.string.mel_November),
            december = stringResource(Res.string.mel_December)
        )
        listMonths = calendarMonths.toList()
        return this
    }

    override fun months(): CalendarMonths {
        return calendarMonths
    }

    override fun getMonthByNumber(number: Int): String {
        return listMonths[number] ?: "null"
    }


}

data class CalendarMonths(
    val january: String,
    val february: String,
    val march: String,
    val april: String,
    val may: String,
    val june: String,
    val july: String,
    val august: String,
    val september: String,
    val october: String,
    val november: String,
    val december: String
) {
    internal fun toList(): List<String?> {
        return listOf(
            null,
            january,
            february,
            march,
            april,
            may,
            june,
            july,
            august,
            september,
            october,
            november,
            december
        )
    }
}

